import { useUser, useUserConfig } from '@/lib/hooks/context'

const useSiteOwnerName = () => {
  const user = useUser()
  const config = useUserConfig()

  return config.siteOwnerName || user.name || ''
}
export default useSiteOwnerName
